import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateSortColumn } from '../../store/lists/actions';

import TableHeader from 'Containers/TableHeader/TableHeader';

class ListTableHeader extends React.PureComponent {
  render() {
    return (
      <TableHeader
        {...this.props}
        handleColumnSort={key =>
          this.props.updateSortColumn(key, this.props.listId)
        }
      />
    );
  }
}

ListTableHeader.propTypes = {
  sortColumn: PropTypes.string,
  columnIds: PropTypes.array,
  sortAscending: PropTypes.bool,
  stickyOffset: PropTypes.number,
  updateSortColumn: PropTypes.func.isRequired,
  listId: PropTypes.string.isRequired,
  headerStuck: PropTypes.bool,
};

export default connect(false, { updateSortColumn })(ListTableHeader);
